import request from '@/utils/request';

export default {
  /**
   * 根据面板id，获取其所有的组件
   * @param panelId
   * @return {*}
   */
  getComponents(panelId) {
    return request.get(`panel/${panelId}/components`);
  },
  /**
   * 得到面板的状态
   * @param panelId
   * @return {*}
   */
  getPanelState(panelId) {
    return request.get(`panel/${panelId}/state`);
  },
  /**
   * 给到工程id，罗列其下所有面板
   * @param projectId
   * @return {*}
   */
  list(projectId) {
    return request.get('panel/list', {
      projectId,
    });
  },
  /**
   * 增加一个面板
   * @param projectId
   * @param panelName
   * @return {*}
   */
  add(projectId, panelName) {
    return request.post('panel/add', {
      projectId,
      panelName,
    });
  },
  /**
   * 保存当前的面板
   * @param panelId
   * @param components 一个包含所有组件数据的列表
   * @return {*}
   */
  save(panelId, components) {
    return request.postJSON('panel/save', {
      panelId,
      components,
    });
  },
  /**
   * 开启面板
   * @param panelId
   * @return {*}
   */
  start(panelId) {
    return request.post('panel/start', {
      panelId,
    });
  },
  /**
   * 重命名设备
   * @param panelId 面板id
   * @return {*}
   */
  stop(panelId) {
    return request.post('panel/stop', {
      panelId,
    });
  },
  /**
   * 重命名面板
   * @param panelId
   * @param newName
   * @return {*}
   */
  rename(panelId, newName) {
    return request.post('panel/rename', {
      panelId,
      name: newName,
    });
  },
  /**
   * 得到与设备相关的文件列表
   * @param panelId
   * @return {*}
   */
  deletePanel(panelId) {
    return request.post('panel/delete', {
      panelId,
    });
  },
  /**
   * 复制面板
   * @param panelId
   * @return {*}
   */
  copy(panelId) {
    return request.post('panel/copy', {
      panelId,
    });
  },
  /**
   * 保存发送配置
   */
  saveSendConfig(messageKey, projectId, componentId, cycle, times, nohup, data) {
    return request.post('component/saveSendConfig', {
      messageKey, projectId, componentId, cycle, times, nohup, data,
    });
  },
  /**
   * 获取发送配置
   */
  getSendConfig(componentId) {
    return request.get(`component/${componentId}/getSendConfig`);
  },
  /**
   * 获取发送信号值
   */
  getSendValue(projectId, dataSourceId) {
    return request.postJson('component/getSendMessageSignalValue', { projectId, dataSourceId });
  },
};



// WEBPACK FOOTER //
// ./src/api/panel.js